import { render } from "./preview-course.vue?vue&type=template&id=77ebc773"
import script from "./preview-course.vue?vue&type=script&lang=js"
export * from "./preview-course.vue?vue&type=script&lang=js"

import "./preview-course.vue?vue&type=style&index=0&id=77ebc773&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__